
<span *ngIf="internalSource" class="{{nbcClass}}">
  <select class="dropdown-toggle form-select {{nbcMismatch}} {{customErrorClass}}" [(ngModel)]="selected"
          name="{{name}}"
          [attr.title]="title?title:null"
          [required]="nbcRequired"
          [attr.disabled]="(!!nbcDisabled || !isAuthorized)||null"
          [attr.authenticate-user]="nbcAuthenticateUser"
          [attr.authenticate-command]="nbcAuthenticateCommand"
          [attr.authenticate-disabled]="nbcAuthenticateDisabled"
          (change)="optionSelected(true)">
    <!--<option *ngIf="placeHolderDisplay" [ngValue]="placeHolderValue">{{placeHolderDisplay}}</option>-->
    <option *ngFor="let opt of internalSource"
            [ngValue]="opt[value]">
      {{opt[display]}}
    </option>
  </select>
</span>
